const DialogoVisivel = ({ referencia, dialogos, children }) => {
  if (!!dialogos[referencia]) {
    return children;
  }
  return null;
};

export default DialogoVisivel;
